import React, { useEffect, useState } from "react";

import {

  useLocation,

  useNavigate,

  useParams,

} from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

import {

  createRazorpayOrder,

  verifyRazorpayPayment,

} from "../../actions/paymentActions";

import { useCart } from "../../components/CartContext";
import { useRestaurantSession } from "../../components/RestaurantSessionProvider";

import "./css/PaymentScreen.css";

function PaymentScreen() {

  const {

    restaurantId,

    tableId,

  } = useParams();

  const navigate = useNavigate();

  const location = useLocation();

  const dispatch = useDispatch();
  const { sessionToken } = useRestaurantSession();

  const {

    clearCart,

  } = useCart();

  /*

  =====================================================

  RESTAURANT NAME

  =====================================================

  */

  const {

    restaurantName,

  } = useSelector(

    (state) => state.theme

  );

  /*

  =====================================================

  PAYMENT REDUX STATE

  =====================================================

  */

  const {

    loading: paymentLoading,

    error: paymentError,

  } = useSelector(

    (state) => state.payment

  );

  /*

  =====================================================

  LOCAL STATE

  =====================================================

  */

  const [

    processing,

    setProcessing,

  ] = useState(false);

  const [

    error,

    setError,

  ] = useState("");

  /*

  =====================================================

  DATA FROM ORDER SCREEN

  =====================================================

  */

  const orderId =

    location.state?.orderId;

  const total =

    Number(

      location.state?.total || 0

    );

  /*

  =====================================================

  CHECK ORDER

  =====================================================

  */

  useEffect(() => {

    setError("");

    if (!orderId) {

      setError(

        "Order information was not found."

      );

    }

  }, [orderId]);

  /*

  =====================================================

  BACK TO ORDER

  =====================================================

  */

  const handleBack = () => {

    navigate(

      `/${restaurantId}/table/${tableId}/order`,

      {

        state: {

          subtotal:

            location.state?.subtotal || 0,

          tax:

            location.state?.tax || 0,

          serviceCharge:

            location.state?.serviceCharge || 0,

          total:

            total,

        },

      }

    );

  };

  /*

  =====================================================

  LOAD RAZORPAY

  =====================================================

  */

  const loadRazorpay = () => {

    return new Promise(

      (resolve) => {

        /*

        -----------------------------------------------

        ALREADY LOADED

        -----------------------------------------------

        */

        if (

          window.Razorpay

        ) {

          resolve(true);

          return;

        }

        /*

        -----------------------------------------------

        CREATE SCRIPT

        -----------------------------------------------

        */

        const script =

          document.createElement(

            "script"

          );

        script.src =

          "https://checkout.razorpay.com/v1/checkout.js";

        script.onload = () => {

          resolve(true);

        };

        script.onerror = () => {

          resolve(false);

        };

        document.body.appendChild(

          script

        );

      }

    );

  };

  /*

  =====================================================

  START PAYMENT

  =====================================================

  */

  const handlePayment = async () => {
    if (processing || paymentLoading) return;
    if (!sessionToken) {
      setError("Dining session is not ready. Please scan the table QR code again.");
      return;
    }

    /*

    -----------------------------------------------

    CHECK ORDER

    -----------------------------------------------

    */

    if (!orderId) {

      setError(

        "Order information is missing."

      );

      return;

    }

    try {

      setProcessing(true);

      setError("");

      /*

      =================================================

      LOAD RAZORPAY

      =================================================

      */

      const razorpayLoaded =

        await loadRazorpay();

      if (!razorpayLoaded) {

        throw new Error(

          "Unable to load payment gateway."

        );

      }

      /*

      =================================================

      CREATE RAZORPAY ORDER

      =================================================

      */

      const razorpayData =

        await dispatch(

          createRazorpayOrder(

            restaurantId,

            orderId,

            sessionToken

          )

        );



      /*

      =================================================

      GET PAYMENT DATA

      =================================================

      */

      const keyId =

        razorpayData?.key_id;

      const razorpayOrderId =

        razorpayData?.razorpay_order_id;

      const amount =

        Number(

          razorpayData?.amount

        );

      if (!Number.isFinite(amount) || amount <= 0) throw new Error("Invalid payment amount returned by the server.");

    const currency =

        razorpayData?.currency ||

        "INR";

      /*

      =================================================

      RESTAURANT NAME

      =================================================

      Backend name has priority.

      Redux theme name is fallback.

      */

      const paymentRestaurantName =

        razorpayData?.restaurant_name ||

        restaurantName ||

        "Restaurant";

      /*

      =================================================

      VALIDATE PAYMENT DATA

      =================================================

      */

      if (!keyId) {

        throw new Error(

          "Payment gateway key was not returned."

        );

      }

      if (!razorpayOrderId) {

        throw new Error(

          "Razorpay order ID was not returned."

        );

      }

      /*

      =================================================

      RAZORPAY OPTIONS

      =================================================

      */

      const options = {

        /*

        ---------------------------------------------

        RAZORPAY KEY

        ---------------------------------------------

        */

        key:

          keyId,

        /*

        ---------------------------------------------

        AMOUNT

        ---------------------------------------------

        */

        amount:

          amount,

        /*

        ---------------------------------------------

        CURRENCY

        ---------------------------------------------

        */

        currency:

          currency,

        /*

        ---------------------------------------------

        RESTAURANT NAME

        ---------------------------------------------

        */

        name:

          paymentRestaurantName,

        /*

        ---------------------------------------------

        DESCRIPTION

        ---------------------------------------------

        */

        description:

          `Order #${orderId}`,

        /*

        ---------------------------------------------

        RAZORPAY ORDER ID

        ---------------------------------------------

        */

        order_id:

          razorpayOrderId,

        /*

        ---------------------------------------------

        THEME

        ---------------------------------------------

        */

        theme: {

          color:

            "#b32622",

        },

        /*

        =================================================

        PAYMENT SUCCESS

        =================================================

        */

        handler:

          async function (

            response

          ) {

            try {

              console.log(

                "Razorpay payment response:",

                response

              );

              /*

              -------------------------------------------

              VERIFY PAYMENT

              -------------------------------------------

              */

              await dispatch(

                verifyRazorpayPayment(

                  restaurantId,

                  {

                    order_id:

                      orderId,

                    razorpay_order_id:

                      response.razorpay_order_id,

                    razorpay_payment_id:

                      response.razorpay_payment_id,

                    razorpay_signature:

                      response.razorpay_signature,

                  },

                  sessionToken

                )

              );

              /*

              -------------------------------------------

              PAYMENT VERIFIED

              -------------------------------------------

              */

              console.log(

                "Payment verified successfully."

              );

              /*

              -------------------------------------------

              CLEAR CART

              -------------------------------------------

              */

              clearCart();

              /*

              -------------------------------------------

              SUCCESS PAGE

              -------------------------------------------

              */

              navigate(

                `/${restaurantId}/table/${tableId}/success`,

                {

                  state: {

                    orderId:

                      orderId,

                    paymentMethod:

                      "ONLINE",

                    total:

                      total,

                  },

                }

              );

            } catch (

              verifyError

            ) {

              console.error(

                "Payment verification error:",

                verifyError

              );

              setError(

                verifyError?.response?.data?.detail ||

                verifyError?.response?.data?.message ||

                verifyError?.message ||

                "Payment verification could not be confirmed. Check payment status before retrying."

              );

              setProcessing(

                false

              );

            }

          },

        /*

        =================================================

        PAYMENT WINDOW CLOSED

        =================================================

        */

        modal: {

          ondismiss:

            function () {

              console.log(

                "Razorpay window closed."

              );

              setProcessing(

                false

              );

            },

        },

        /*

        =================================================

        PREFILL

        =================================================

        */

        prefill: {

          name:

            "",

          email:

            "",

          contact:

            "",

        },

        /*

        =================================================

        NOTES

        =================================================

        */

        notes: {

          order_id:

            String(orderId),

          restaurant_id:

            String(restaurantId),

        },

        /*

        =================================================

        RETRY

        =================================================

        */

        retry: {

          enabled:

            true,

          max_count:

            2,

        },

      };

      /*

      =================================================

      CREATE RAZORPAY INSTANCE

      =================================================

      */

      const razorpay =

        new window.Razorpay(

          options

        );

      /*

      =================================================

      PAYMENT FAILED

      =================================================

      */

      razorpay.on(

        "payment.failed",

        function (

          response

        ) {

          console.error(

            "Razorpay payment failed:",

            response

          );

          setError(

            response?.error?.description ||

            "Payment failed. Please try again."

          );

          setProcessing(

            false

          );

        }

      );

      /*

      =================================================

      OPEN RAZORPAY

      =================================================

      */

      razorpay.open();

    } catch (err) {

      console.error(

        "Payment error:",

        err

      );

      setError(

        err?.response?.data?.detail ||

        err?.response?.data?.message ||

        err?.message ||

        "Unable to start payment."

      );

      setProcessing(

        false

      );

    }

  };

  /*

  =====================================================

  NO ORDER

  =====================================================

  */

  if (!orderId) {

    return (

      <div className="theme3-payment-page">

        <div className="theme3-payment-container">

          <div className="theme3-payment-error-page">

            <div className="theme3-payment-error-icon">

              !

            </div>

            <h1>

              PAYMENT UNAVAILABLE

            </h1>

            <p>

              We could not find the order

              required to start payment.

            </p>

            <button

              type="button"

              className="theme3-payment-primary-button"

              onClick={() =>

                navigate(

                  `/${restaurantId}/table/${tableId}`

                )

              }

            >

              RETURN TO MENU

            </button>

          </div>

        </div>

      </div>

    );

  }

  /*

  =====================================================

  MAIN PAYMENT PAGE

  =====================================================

  */

  return (

    <div className="theme3-payment-page">

      <div className="theme3-payment-container">

        {/* =================================================

            BACK

        ================================================= */}

        <button

          type="button"

          className="theme3-payment-back"

          onClick={handleBack}

          disabled={processing}

        >

          <span>

            ←

          </span>

          BACK TO ORDER

        </button>

        {/* =================================================

            HEADING

        ================================================= */}

        <div className="theme3-payment-heading">

          <span className="theme3-payment-eyebrow">

            SECURE PAYMENT

          </span>

          <h1>

            PAYMENT

          </h1>

          <p>

            Complete your payment securely

            to confirm your order.

          </p>

        </div>

        {/* =================================================

            PAYMENT LAYOUT

        ================================================= */}

        <div className="theme3-payment-layout">

          {/* =================================================

              LEFT

          ================================================= */}

          <div className="theme3-payment-main">

            {/* =================================================

                PAYMENT METHOD CARD

            ================================================= */}

            <div className="theme3-payment-method-card">

              <div className="theme3-payment-method-icon">

                ◇

              </div>

              <div className="theme3-payment-method-content">

                <span>

                  PAYMENT METHOD

                </span>

                <h2>

                  ONLINE PAYMENT

                </h2>

                <p>

                  You will be securely redirected

                  to Razorpay to complete your

                  payment.

                </p>

              </div>

              <div className="theme3-payment-secure-badge">

                SECURE

              </div>

            </div>

            {/* =================================================

                ORDER INFORMATION

            ================================================= */}

            <div className="theme3-payment-information">

              <div className="theme3-payment-information-row">

                <span>

                  RESTAURANT

                </span>

                <strong>

                  {restaurantName ||

                    "Restaurant"}

                </strong>

              </div>

              <div className="theme3-payment-information-row">

                <span>

                  ORDER

                </span>

                <strong>

                  #{orderId}

                </strong>

              </div>

              <div className="theme3-payment-information-row">

                <span>

                  PAYMENT

                </span>

                <strong>

                  ONLINE

                </strong>

              </div>

              <div className="theme3-payment-information-row">

                <span>

                  CURRENCY

                </span>

                <strong>

                  INR ₹

                </strong>

              </div>

            </div>

            {/* =================================================

                ERROR

            ================================================= */}

            {(error ||

              paymentError) && (

              <div className="theme3-payment-error">

                {error ||

                  (

                    typeof paymentError ===

                    "string"

                      ? paymentError

                      : "Payment could not be started."

                  )}

              </div>

            )}

            {/* =================================================

                PAY BUTTON

            ================================================= */}

            <button

              type="button"

              className="theme3-payment-pay-button"

              onClick={handlePayment}

              disabled={

                processing ||

                paymentLoading ||
                !sessionToken

              }

            >

              {processing ||

              paymentLoading ? (

                <>

                  <span className="theme3-payment-spinner"></span>

                  PROCESSING...

                </>

              ) : (

                <>

                  PAY ₹

                  {total.toFixed(2)}

                  <span>

                    →

                  </span>

                </>

              )}

            </button>

            {/* =================================================

                SECURITY MESSAGE

            ================================================= */}

            <div className="theme3-payment-security">

              <span>

                🔒

              </span>

              <p>

                Payments are processed securely

                through Razorpay. Your card or

                banking details are handled by the

                payment gateway.

              </p>

            </div>

          </div>

          {/* =================================================

              RIGHT SUMMARY

          ================================================= */}

          <aside className="theme3-payment-summary">

            <div className="theme3-payment-summary-heading">

              <span>

                ORDER SUMMARY

              </span>

              <div></div>

            </div>

            {/* ORDER */}

            <div className="theme3-payment-summary-row">

              <span>

                ORDER NUMBER

              </span>

              <strong>

                #{orderId}

              </strong>

            </div>

            {/* RESTAURANT */}

            <div className="theme3-payment-summary-row">

              <span>

                RESTAURANT

              </span>

              <strong>

                {restaurantName ||

                  "Restaurant"}

              </strong>

            </div>

            {/* PAYMENT */}

            <div className="theme3-payment-summary-row">

              <span>

                PAYMENT METHOD

              </span>

              <strong>

                ONLINE

              </strong>

            </div>

            <div className="theme3-payment-summary-divider"></div>

            {/* TOTAL */}

            <div className="theme3-payment-total">

              <div>

                <span>

                  AMOUNT TO PAY

                </span>

                <small>

                  INCLUDING ALL CHARGES

                </small>

              </div>

              <strong>

                ₹{total.toFixed(2)}

              </strong>

            </div>

            {/* NOTE */}

            <div className="theme3-payment-summary-note">

              <span>

                ✦

              </span>

              <p>

                Your order will be confirmed

                after successful payment

                verification.

              </p>

            </div>

          </aside>

        </div>

      </div>

    </div>

  );

}

export default PaymentScreen;